// @ts-expect-error not converted to TS
import MobileUA from 'PatternValidationJS/patterns/MobileUA';
//@ts-expect-error Untyped module
import isMobile from 'isMobile';
const getUserDeviceInfo = () => {
  return new isMobile.Class(navigator.userAgent);
};
const USER_AGENT = navigator.userAgent;
const DEVICE_TYPE = {
  mobile: 'mobile',
  ios: 'ios',
  android: 'android',
  desktop: 'desktop'
};
export const getIsMobile = () => MobileUA.test(USER_AGENT);
export const getUserDeviceType = () => {
  const deviceInfo = getUserDeviceInfo();
  if (deviceInfo.apple.device) {
    return DEVICE_TYPE.ios;
  }
  if (deviceInfo.android.device) {
    return DEVICE_TYPE.android;
  }
  if (deviceInfo.any) {
    return DEVICE_TYPE.mobile;
  }
  return DEVICE_TYPE.desktop;
};